import { MessageScreen } from '@/components/MessageScreen/MessageScreen';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

export const Success = () => {
  const { content, locale } = useConfig();

  useAirKeyTracePageView('success');

  return (
    <MessageScreen
      iconPath={`${content.config.urlBase}${content.success.img.src}`}
      iconSize={content.success.img.width}
      title={content.success.title[locale]}
      titleSize={25}
      body={content.success.description[locale]}
    />
  );
};
